export default __webpack_public_path__ + "static/media/card-active.7e1e967f.svg";